module.exports = __webpack_public_path__ + "static/media/Omitir.4b789a99.png";